import React from "react";
import { Loader2 } from "lucide-react";

const variantStyles = {
  primary: {
    background: "#028D93",
    color: "#fff",
    border: "none",
  },
  secondary: {
    background: "#fff",
    color: "#00293A",
    border: "1px solid #dfe8ee",
  },
  ghost: {
    background: "transparent",
    color: "#475569",
    border: "none",
    boxShadow: "none",
  },
};

export default function Button({
  children,
  className = "",
  icon: Icon,
  isLoading = false,
  variant = "primary",
  type = "button",
  style: externalStyle,
  ...props
}) {
  const base = {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    minHeight: "44px",
    padding: "8px 16px",
    fontSize: "14px",
    fontWeight: 600,
    borderRadius: "8px",
    cursor: props.disabled || isLoading ? "not-allowed" : "pointer",
    opacity: props.disabled || isLoading ? 0.6 : 1,
    boxShadow: "0 1px 2px rgba(0,0,0,0.06)",
    transition: "all 0.15s ease",
    fontFamily: "inherit",
    ...variantStyles[variant],
    ...externalStyle,
  };

  return (
    <button
      className={className}
      disabled={isLoading || props.disabled}
      type={type}
      style={base}
      {...props}
    >
      {isLoading ? (
        <Loader2 style={{ width: "16px", height: "16px", animation: "spin 1s linear infinite" }} />
      ) : Icon ? (
        <Icon style={{ width: "16px", height: "16px" }} />
      ) : null}
      {children}
    </button>
  );
}
